import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Card, CardContent, CardMedia, Chip, Grid, Typography, Tooltip } from '@mui/material';

// project imports
//import Avatar3 from 'src/assets/images/konsep_2..png';
import Avatar from 'src/components/extended/Avatar';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
// const avatarImage = require.context('assets/images/users', true);
// const profileImage = require.context('assets/images/profile', true);

// styles



// ==============================|| USER PROFILE CARD ||============================== //

const ServiceProfileCard = ({
    avatar, name, profile, Avatar3, role, status, type, email, phone, location, openDate, address, id,
    personelCount, vehicleCount, setOpenEditPopUp, setSelectedServiceName, setSelectedBirim, setSelectedServiceAddress,
    onClick // yeni prop
}) => {
    const theme = useTheme();
    const getBackgroundColor = (status) => {
        if (theme.palette.mode === 'dark') {
            switch (status) {
                case 'A+':
                    return '#004d00'; // dark green
                case 'A':
                    return '#006600'; // green
                case 'B':
                    return '#666600'; // yellow
                case 'C':
                    return '#994d00'; // orange
                case 'D':
                    return '#990000'; // red
                case 'E':
                    return '#660000'; // dark red
                default:
                    return 'success.light';
            }
        } else {
            switch (status) {
                case 'A+':
                    return '#4caf50'; // light green
                case 'A':
                    return '#66bb6a'; // green
                case 'B':
                    return '#ffeb3b'; // yellow
                case 'C':
                    return '#ffa726'; // orange
                case 'D':
                    return '#f44336'; // red
                case 'E':
                    return '#d32f2f'; // dark red
                default:
                    return 'success.light';
            }
        }
    };

    const getTextColor = (status) => {
        // Tüm durumlar için beyaz metin rengi
        return theme.palette.common.white;
    };



    return (
        <Card
            sx={{
                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                border: '1px solid',
                borderColor: theme.palette.grey[100],
                textAlign: 'center',
                '&:hover': {
                    borderColor: '#FF9800',
                }
            }}
            onClick={onClick} // ana kapsayıcıya eklendi
        >
            <CardMedia
                component="img"
                image={Avatar3} // Base64 string
                title="Slider5 image"
                sx={{
                    height: '125px',
                    width: '100%',
                    objectFit: 'contain', // Görseli CardMedia'nın içinde tutar, taşırmaz
                    backgroundColor: '#f0f0f0', // İsteğe bağlı: Boş kalan alanlara arka plan verir
                }}
            />
            <CardContent sx={{ p: 2, pb: '16px !important' }}>
                <Grid container spacing={3}>
                    <Grid size={12}>
                        <Grid container spacing={3}>
                            <Grid size={12}>
                                <Avatar alt={name} src={avatar} sx={{ width: 72, height: 72, m: '-50px auto 0' }} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid alignItems="center" size={12}>
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant="h4">{name}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        height: '3em', // approximate height for 2 lines
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'normal',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical'
                                    }}
                                >
                                    {role}
                                </Typography>
                            </Grid>
                            <Grid size={12}>
                                <Tooltip title="Büyüklük Konumu" arrow>
                                    <Chip
                                        label={status}
                                        size="medium"  // Chip boyutunu büyütmek için small yerine medium kullandık
                                        sx={{
                                            bgcolor: getBackgroundColor(status),
                                            color: getTextColor(status),  // Metin rengini güncelledik
                                            fontSize: '1rem',  // Yazı boyutunu büyüttük
                                            height: '28px',  // Chip'in yüksekliğini ayarladık
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid size={12}>
                                <Typography
                                    sx={{
                                        fontSize: '2rem',
                                        typography: 'body2', // variant'ı burada belirtiyoruz
                                    }}
                                >
                                    {type}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={3}>
                            <Grid sx={{ textAlign: 'left' }} size={6}>
                                <Typography variant="caption">Çalışan Sayısı</Typography>
                                <Typography variant="h6">{personelCount}</Typography>
                            </Grid>
                            <Grid sx={{ textAlign: 'left' }} size={6}>
                                <Typography variant="caption">Araç Sayısı</Typography>
                                <Typography variant="h6">{vehicleCount}</Typography>
                            </Grid>
                            <Grid sx={{ textAlign: 'left' }} size={6}>
                                <Typography variant="caption">Telefon</Typography>
                                <Typography variant="h6">{phone}</Typography>
                            </Grid>
                            <Grid sx={{ textAlign: 'left' }} size={6}>
                                <Typography variant="caption">Email</Typography>
                                <Typography variant="h6">{email}</Typography>
                            </Grid>
                            <Grid sx={{ textAlign: 'left' }} size={6}>
                                <Typography variant="caption">Şehir</Typography>
                                <Typography variant="h6">{location}</Typography>
                            </Grid>
                            <Grid sx={{ textAlign: 'left' }} size={6}>
                                <Typography variant="caption">Açılış Tarihi</Typography>
                                <Typography variant="h6">{openDate}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Button
                            variant="outlined"
                            fullWidth startIcon={<EditTwoToneIcon />}
                            onClick={() => {
                                setSelectedServiceName(name);
                                setOpenEditPopUp(true);
                                setSelectedBirim(id);
                                setSelectedServiceAddress(address);
                            }}
                        >
                            Düzenle
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

ServiceProfileCard.propTypes = {
    avatar: PropTypes.string,
    name: PropTypes.string,
    profile: PropTypes.string,
    role: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    location: PropTypes.string,
    openDate: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    personelCount: PropTypes.number,
    vehicleCount: PropTypes.number,
    setOpenEditPopUp: PropTypes.func,
    setSelectedServiceName: PropTypes.func,
    setSelectedBirim: PropTypes.func
};

export default ServiceProfileCard;
